export function dutyOf(emp, st) {
    if (emp.custom)
        return (emp.duties[st.id] ?? 0);
    if (emp.level == null)
        return 0;
    return (st.levels[emp.level] ?? 0);
}
/** Out of service (set by an admin) on this date? */
export function isOutOfService(st, isoDate) {
    if (!st.outOfService)
        return false;
    if (st.outFrom && isoDate < st.outFrom)
        return false;
    if (st.outUntil && isoDate > st.outUntil)
        return false;
    return true;
}
function lv(levels, star = []) {
    const o = {};
    for (const n of levels)
        o[n] = 1;
    for (const n of star)
        o[n] = 2;
    return o;
}
const base = { takesOverflow: false, fullHourOnly: false, breakRule: 0, firstSpotNeedsStar: false, highestLevelFirst: false, onDemand: false, shareGroups: [] };
export const DEFAULT_STATIONS = [
    { ...base, kind: 'manager', code: 'mgr', breakPref: 'a1', name: 'Manager', sortOrder: 1, stdCount: 1, busyCount: 1, levels: lv([7, 8, 9]), highestLevelFirst: true },
    { ...base, kind: 'lead', code: 'lead', breakPref: 'a1', name: 'Shift Lead', sortOrder: 2, stdCount: 1, busyCount: 1, levels: lv([6, 7, 8]) },
    { ...base, kind: 'station', code: 'adm', breakPref: 'p5', name: 'Admissions', sortOrder: 3, stdCount: 2, busyCount: 3, levels: lv([2, 3, 4, 5, 6, 7, 8]), takesOverflow: true },
    { ...base, kind: 'station', code: 'kart', breakPref: 'last', shareGroups: [1], name: 'Go Karts', sortOrder: 4, stdCount: 3, busyCount: 4, levels: lv([4], [5]), fullHourOnly: true, breakRule: 1, firstSpotNeedsStar: true },
    { ...base, kind: 'station', code: 'conc', breakPref: 'p4', name: 'Concessions', sortOrder: 5, stdCount: 1, busyCount: 2, levels: lv([2, 3, 4, 5, 6, 7, 8]), takesOverflow: true },
    { ...base, kind: 'station', code: 'redmp', breakPref: 'p3', name: 'Redemption', sortOrder: 6, stdCount: 1, busyCount: 1, levels: lv([1, 2, 3, 4, 5, 6, 7, 8]), takesOverflow: true },
    { ...base, kind: 'station', code: 'pixel', breakPref: 'a1', shareGroups: [1], name: 'Pixel', sortOrder: 7, stdCount: 1, busyCount: 1, levels: lv([1, 2, 3, 4, 5]), fullHourOnly: true },
    { ...base, kind: 'station', code: 'ltag', breakPref: 'a2', shareGroups: [1], name: 'Laser Tag', sortOrder: 8, stdCount: 1, busyCount: 1, levels: lv([3, 4, 5]), fullHourOnly: true },
    { ...base, kind: 'station', code: 'floor', breakPref: 'p2', name: 'Floor', sortOrder: 9, stdCount: 1, busyCount: 2, levels: lv([1, 2, 3, 4, 5]), takesOverflow: true },
    { ...base, kind: 'station', code: 'party', breakPref: 'p6', onDemand: true, name: 'Party', sortOrder: 10, stdCount: 1, busyCount: 1, levels: lv([2, 3, 4, 5]), takesOverflow: true },
    { ...base, kind: 'station', code: 'float', breakPref: 'p1', name: 'Floater', sortOrder: 11, stdCount: 1, busyCount: 2, levels: lv([2, 3, 4, 5]), takesOverflow: true },
    { ...base, kind: 'station', code: 'train', breakPref: 'none', name: 'Training', sortOrder: 12, stdCount: 0, busyCount: 0, levels: lv([0]), takesOverflow: true },
];
/** Short titles for the level key (admins can rename later). */
export const LEVEL_TITLES = {
    9: 'Manager', 8: 'Assistant manager', 7: 'Day manager', 6: 'Shift lead',
    5: 'All activities', 4: 'Karts (secondary)', 3: 'Laser tag, no karts',
    2: 'No karts or laser tag', 1: 'Basic stations', 0: 'Training',
};
//# sourceMappingURL=stations.js.map